<div class="content">
  <div class="prefix-wrapper">
    <ng-content select="[prefix]"></ng-content>
  </div>

  <div class="content-wrapper">
    <ng-content></ng-content>
  </div>

  <ng-container *ngIf="href">
    <a [href]="href" [target]="hrefTarget ? hrefTarget : '_self'"></a>
  </ng-container>

  <div class="suffix-wrapper" layout-horizontal>
    <ng-content select="[suffix]"></ng-content>

    <div *ngIf="hasChevronRight">
      <rt-icon name="chevron-right"></rt-icon>
    </div>

    <div *ngIf="isSelected">
      <rt-icon class="check-icon" name="check"></rt-icon>
    </div>
  </div>
</div>

<rt-divider *ngIf="!isLast && !(!isLast && noDivider)"></rt-divider>
